module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-background-627acb814e7be1aa33ddc4f5bd475019.jpg";